import React from 'react';
import PropTypes from 'prop-types';
import './WaitingBlock.css';
import Spinner from '../Spinner';

const WaitingBlock = ({ children, loader = <Spinner /> }) => {
    return (
        <div className="wz-lyriapay-waitingblock">
            <div>{loader}</div>
            <div>{children}</div>
        </div>
    );
};

WaitingBlock.propTypes = {
    children: PropTypes.node.isRequired,
    loader: PropTypes.node
};

export default WaitingBlock;
